import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';

const CATEGORIEEN = ['Werkorders', 'Planning', 'Monteurs-app', 'Storingen', 'Forms', 'Rapportage', 'Anders'];
const STATUS = {
  nieuw:     { label: 'Nieuw',         kleur: '#3b82f6' },
  bekeken:   { label: 'Bekeken',       kleur: '#8b5cf6' },
  gepland:   { label: 'Gepland',       kleur: '#f59e0b' },
  klaar:     { label: 'Gemaakt',       kleur: '#10b981' },
  afgewezen: { label: 'Niet haalbaar', kleur: '#9ca3af' },
};
const fmt = (d) => new Date(d).toLocaleDateString('nl-NL', { day: '2-digit', month: 'short', year: 'numeric' });
const inp = { width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, fontFamily: 'inherit', boxSizing: 'border-box' };
const badge = (k) => ({ padding: '4px 12px', borderRadius: 20, background: k, color: '#fff', fontSize: 13, fontWeight: 600, whiteSpace: 'nowrap' });

export default function Ideeen() {
  const { gebruiker } = useAuth();
  const magBeheren = String(gebruiker?.rol || '').toLowerCase() === 'super_admin' || Number(gebruiker?.rol_id) === 4;
  const [ideeen, setIdeeen] = useState([]);
  const [loading, setLoading] = useState(true);
  const [titel, setTitel] = useState('');
  const [omschrijving, setOmschrijving] = useState('');
  const [categorie, setCategorie] = useState('Werkorders');
  const [bezig, setBezig] = useState(false);
  const [melding, setMelding] = useState('');
  const [filter, setFilter] = useState('alle');

  const laden = async () => {
    try { const r = await api.get('/ideeen'); setIdeeen(r.data.ideeen || []); }
    catch { setMelding('Ideeën laden mislukt.'); }
    finally { setLoading(false); }
  };
  useEffect(() => { laden(); }, []);

  const indienen = async () => {
    if (titel.trim().length < 3) { setMelding('Geef je idee een titel.'); return; }
    setBezig(true); setMelding('');
    try {
      await api.post('/ideeen', { titel: titel.trim(), omschrijving: omschrijving.trim(), categorie });
      setTitel(''); setOmschrijving(''); setMelding('Idee ingediend.'); laden();
    } catch (e) { setMelding(e.response?.data?.message || 'Indienen mislukt.'); }
    finally { setBezig(false); }
  };

  const stem = async (id) => {
    try {
      const r = await api.post(`/ideeen/${id}/stem`);
      setIdeeen((l) => l.map((i) => (i.id === id ? { ...i, ...r.data } : i)));
    } catch { setMelding('Stemmen mislukt.'); }
  };

  const bijwerken = async (id, velden) => {
    try { await api.patch(`/ideeen/${id}`, velden); setIdeeen((l) => l.map((i) => (i.id === id ? { ...i, ...velden } : i))); }
    catch { setMelding('Bijwerken mislukt.'); }
  };

  const zichtbaar = filter === 'alle' ? ideeen
    : filter === 'mijn' ? ideeen.filter((i) => i.gebruiker_id === gebruiker?.id)
    : ideeen.filter((i) => i.status === filter);
  const chips = [['alle', `Alle (${ideeen.length})`], ['mijn', 'Mijn ideeën'],
    ...Object.entries(STATUS).map(([k, v]) => [k, `${v.label} (${ideeen.filter((i) => i.status === k).length})`])];

  return (
    <div className="ideeen-page">
      <div className="page-header">
        <div className="page-header-left">
          <h1>💡 Ideeën</h1>
          <span className="welcome-text">{magBeheren ? 'Aanvragen van alle bedrijven, gesorteerd op stemmen.' : 'Mis je iets, of kan het slimmer? Zet het hier neer.'}</span>
        </div>
      </div>

      {!magBeheren && (
      <div className="info-card" style={{ marginBottom: 24 }}>
        <h3>Nieuw idee</h3>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 200px', gap: 12, marginTop: 12 }}>
          <input placeholder="Wat wil je dat WOMsys kan?" value={titel} onChange={(e) => setTitel(e.target.value)} maxLength={120} style={inp} />
          <select value={categorie} onChange={(e) => setCategorie(e.target.value)} style={inp}>
            {CATEGORIEEN.map((c) => <option key={c}>{c}</option>)}
          </select>
        </div>
        <textarea placeholder="Wanneer loop je hier tegenaan, en wat zou je willen dat er gebeurt?" value={omschrijving}
          onChange={(e) => setOmschrijving(e.target.value)} rows={4} style={{ ...inp, marginTop: 12, resize: 'vertical' }} />
        <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginTop: 12 }}>
          <button onClick={indienen} disabled={bezig} style={{ background: '#3b82f6', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 18px', fontWeight: 600, cursor: 'pointer', opacity: bezig ? 0.6 : 1 }}>{bezig ? 'Indienen…' : 'Idee indienen'}</button>
          {melding && <span style={{ color: '#6b7280', fontSize: 14 }}>{melding}</span>}
        </div>
      </div>
      )}

      <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
        {chips.map(([k, label]) => (
          <button key={k} onClick={() => setFilter(k)} style={{ padding: '6px 14px', borderRadius: 20, border: '1px solid #e5e7eb', cursor: 'pointer',
            background: filter === k ? '#111827' : '#fff', color: filter === k ? '#fff' : '#374151', fontSize: 13 }}>{label}</button>
        ))}
      </div>

      {loading ? <p style={{ color: '#6b7280' }}>Laden…</p>
      : zichtbaar.length === 0 ? <div className="info-card" style={{ textAlign: 'center', color: '#6b7280' }}>Nog geen ideeën. Het eerste is aan jou.</div>
      : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {zichtbaar.map((i) => {
            const s = STATUS[i.status] || STATUS.nieuw;
            return (
              <div key={i.id} className="info-card" style={{ borderLeft: `4px solid ${s.kleur}` }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12 }}>
                  <button onClick={() => stem(i.id)} title={i.ik_stemde ? 'Stem intrekken' : 'Ik wil dit ook'}
                    style={{ minWidth: 56, padding: '8px 4px', borderRadius: 10, cursor: 'pointer', textAlign: 'center',
                      border: `1px solid ${i.ik_stemde ? '#3b82f6' : '#e5e7eb'}`, background: i.ik_stemde ? '#eff6ff' : '#fff', color: i.ik_stemde ? '#1d4ed8' : '#374151' }}>
                    <div style={{ fontSize: 16 }}>👍</div><div style={{ fontWeight: 700 }}>{i.stemmen}</div>
                  </button>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 600, fontSize: 16 }}>{i.titel}</div>
                    <div style={{ color: '#6b7280', fontSize: 13, marginTop: 4 }}>
                      {i.bedrijf_naam && <span style={{ background: '#111827', color: '#fff', padding: '2px 8px', borderRadius: 6, fontSize: 12, fontWeight: 600, marginRight: 8 }}>{i.bedrijf_naam}</span>}{i.categorie} · {i.voornaam} {i.achternaam} · {fmt(i.created_at)}
                    </div>
                    {i.omschrijving && <p style={{ marginTop: 10, whiteSpace: 'pre-wrap', color: '#374151' }}>{i.omschrijving}</p>}
                    {i.reactie && <div style={{ marginTop: 10, padding: '10px 12px', background: '#f3f4f6', borderRadius: 8, fontSize: 14 }}><strong>Reactie:</strong> {i.reactie}</div>}
                  </div>
                  {magBeheren ? (
                    <select value={i.status} onChange={(e) => bijwerken(i.id, { status: e.target.value })} style={{ ...badge(s.kleur), border: 'none', cursor: 'pointer' }}>
                      {Object.entries(STATUS).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
                    </select>
                  ) : <span style={badge(s.kleur)}>{s.label}</span>}
                </div>
                {magBeheren && (
                  <input placeholder="Reactie voor de indiener (Enter om op te slaan)" defaultValue={i.reactie || ''}
                    onKeyDown={(e) => { if (e.key === 'Enter') bijwerken(i.id, { reactie: e.target.value }); }} style={{ ...inp, marginTop: 12, fontSize: 13 }} />
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
